import { Head } from '@inertiajs/react';

export default function Welcome() {
    return (
        <>
            <Head title="Welcome" />
            <main className="flex justify-center">
                Welcome to the playground.
            </main>
        </>
    );
}
